import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import get from "lodash/get";
import { SocialShare } from "@quintype/components";
import { SearchBox } from "../../molecules/SearchBox";

import { Button, Headline } from "../../atoms";
import { useDeviceType } from "../../customHooks/useDeviceType";
import { STATIC_KEYWORDS } from "../../../constants";
import { StoryCard } from "../../molecules";
import { SocialShareTemplate } from "../../../arrow";
import ListingAdSlot from "../../molecules/ListingAdSlot";
import { getAdvancedSearchItems } from "../../../../api/utils";
import { trackLoadMoreClick } from "../../utils";

import "./search.m.css";

const SearchPage = (props) => {
  const sketchesHost = get(props, ["config", "sketches-host"]);
  const { LOAD_MORE, SEARCH } = STATIC_KEYWORDS;
  const [offset, setOffset] = useState(11);
  const [limit, setLimit] = useState(11);
  const [stories, setStories] = useState(props?.data?.stories);
  const { total, query } = get(props, ["data"], []);
  const deviceType = useDeviceType();
  const isDesktop = deviceType === "desktop";
  const [hideLoadMore, setHideLoadMore] = useState(false);
  const scrollPosition = useRef(0);

  const qtState = useSelector((state) => get(state, ["qt"], {}));
  const isAdfreePage = get(qtState, ["config", "subscriber"]) === "true";

  function DrawForm({ children }) {
    return [
      <label htmlFor="searchForm" key="1" style={{ width: "100%" }}>
        {children}
      </label>,
      <Button key="2" customStyleName="bg-brand-primary">
        {SEARCH}
      </Button>,
    ];
  }

  useEffect(() => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "dl_page_info",
      cms_author_name: "NA",
      byline: "NA",
      category: "search",
      sub_category: "NA",
      content_id: "NA",
      template_name: "listing",
      publish_date: "NA",
      publish_time: "NA",
      login_status: "not-logged-in", // will be changed
      subscription_status: "not-subscribed", // will be changed
      ad_free: false, // will be changed
      login_wall_enabled: false,
      platform: window.innerWidth >= 768 ? "Desktop" : "Mobile",
    });
  }, []);

  useEffect(() => {
    !stories && setHideLoadMore(true);
    const remaining = total - stories?.length;
    setOffset(stories?.length);
    remaining < limit && setLimit(remaining);
    remaining <= 0 && setHideLoadMore(true);
  }, [stories]);

  const getMoreStories = async (offset, limit) => {
    trackLoadMoreClick({
      linkCategory: "search",
      category: "search",
      subCategory: query,
      templateName: "listing",
    });
    const newStories = await getAdvancedSearchItems("q", query, offset, limit);
    setStories((prevStories) => [...prevStories, ...newStories]);
  };

  const Header = () => {
    const qtState = useSelector((state) => get(state, ["qt"], {}));
    const pageType = get(qtState, ["pageType"], null);
    const config = get(qtState, ["config"], "");
    const fromLocation = get(qtState, ["data", "story"], {});
    return (
      <div styleName="header">
        <div styleName="search-page-title">
          <div styleName="title-wrapper">
            <Headline type={1}>{query || "Search Page"}</Headline>
            <p styleName="total-stories">{`(${total} search result${total === 1 ? "" : "s"})`}</p>
          </div>

          {total ? (
            <SocialShare
              template={SocialShareTemplate}
              fullUrl={encodeURI(`${sketchesHost}${props?.currentPath}`)}
              title={props?.data?.query}
            />
          ) : (
            ""
          )}
        </div>
        <div styleName="search-form">
          <SearchBox
            styleName="search-box"
            template={DrawForm}
            inputId="searchForm"
            inputClassName="search__form-input"
            placeholder="Search"
            initValue={query}
            searchType="search-result"
            pageType={pageType}
            config={config}
            fromLocation={fromLocation}
          />
        </div>
      </div>
    );
  };

  return (
    <div className="container" styleName="search-page-container">
      <Header />
      {!query ? (
        <div styleName="not-found-text">Please search for any topic to get results.</div>
      ) : total === 0 ? (
        <div styleName="not-found-text">Oops! We couldn’t find any results for '{query}' Please try again.</div>
      ) : (
        <div styleName="stories-container">
          {stories?.map((story, index) => (
            <>
              <StoryCard story={story?.story} showAuthorContent={false} isAdfreePage={isAdfreePage} />
              {!isAdfreePage && index === (isDesktop ? 1 : 0) && (
                <ListingAdSlot
                  adType={"right_side"}
                  index={index}
                  pageType={"tag-page"}
                  adStyleName="ad-slot-size-300x250"
                  adSlotConfigName="mRec_ad"
                />
              )}
              {!isAdfreePage && (index === 6 || ((index - 11) % 5 === 0 && index - 11 >= 0)) && isDesktop && (
                <ListingAdSlot
                  adType={"grid_ad"}
                  index={index}
                  pageType={"tag-page"}
                  adStyleName="ad-slot-size-300x250"
                  adSlotConfigName="mRec_ad"
                />
              )}
              {!isAdfreePage && index % 3 === 0 && index > 0 && !isDesktop && (
                <div styleName="search-ad-container">
                  <ListingAdSlot
                    adType={"grid_ad"}
                    index={index}
                    pageType={"tag-page"}
                    adStyleName="ad-slot-size-300x250"
                    adSlotConfigName="mRec_ad"
                  />
                </div>
              )}
            </>
          ))}
        </div>
      )}
      {!hideLoadMore && (
        <div styleName="load-more-button">
          <Button
            onClickFunction={() => {
              getMoreStories(offset, limit);
            }}
          >
            {LOAD_MORE}
          </Button>
        </div>
      )}
    </div>
  );
};

SearchPage.propTypes = {
  data: PropTypes.object,
};

export { SearchPage };
